var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-background",style:({ 'background-color': _vm.lightMode ? '#62A0F0' : '#021F23' })},[_c('div',{staticClass:"background-landscape",class:{ 'light-mode': _vm.lightMode,'dark-mode': !_vm.lightMode }})])}
var staticRenderFns = []

export { render, staticRenderFns }